"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  module: {
    position: "relative",
    width: "100%",
    //        minHeight: "240px",
    backgroundColor: "#f2f2f2",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "13px",
    lineHeight: 1.5,
    display: "flex",
    flexDirection: "column"
  },
  media: {
    position: "relative",
    width: "100%",
    paddingBottom: "100%",
    flexBasis: 0,
    flexGrow: 1,
    margin: 0
  },
  image: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    maxWidth: "90%",
    maxHeight: "90%",
    margin: "auto"
  },
  content: {
    flexBasis: 0,
    flexGrow: 1,
    padding: theme.spacing(.5),
    minHeight: "5em"
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "1em",
    lineHeight: 1.25,
    maxHeight: "3.75em",
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical"
  },
  footer: {
    flexBasis: 0,
    flexGrow: 0
  }
}));

const ModuleEkultur = ({
  size,
  documentType,
  imageUrl,
  title,
  author,
  objectCount,
  imageCount,
  videoCount,
  audioCount,
  commentCount
}) => {
  const classes = useStyles();
  let metadata = [];

  if (objectCount) {
    metadata.push(objectCount + ' objekter');
  }

  if (imageCount) {
    metadata.push(imageCount + ' bilder');
  }

  if (videoCount) {
    metadata.push(videoCount + ' videoer');
  }

  if (audioCount) {
    metadata.push(audioCount + ' lydklipp');
  }

  metadata = metadata.length && metadata.join(', ');
  return _react.default.createElement("article", {
    className: classes.module
  }, _react.default.createElement("figure", {
    className: classes.media
  }, _react.default.createElement("img", {
    className: classes.image,
    src: imageUrl
  })), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_Typography.default, {
    className: classes.title
  }, title)), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement("p", null), _react.default.createElement("b", {
    className: "comments__label"
  }, commentCount))));
};

var _default = ModuleEkultur;
exports.default = _default;
module.exports = exports.default;